import { RootState } from '../../../reducers/index'
import { CustomFile } from '../../../../model/File'

export function inUseMedicalEventFileSelector(state: RootState): CustomFile | null {
  const filesResources = state.cache.files.details
  const inUseId = state.ui.medicalEvent.files.inUse.inUseId

  return inUseId ? filesResources[inUseId] : null
}
